import {useDisclose} from "@hosttools/frontend";
import {Center, Popover} from "@hosttools/frontend/components";
import type {Listing} from "@hosttools/frontend/models/listing";
import type {ListingGroup} from "@hosttools/frontend/models/listingGroup";
import type React from "react";
import {memo} from "react";

import TopNavMenuItem from "@/client/components/Header/TopNavMenuItem";
import MessagingMenu from "@/client/components/NavMessaging/MessagingMenu";
import Text from "@/client/components/Text";

type Props = {
    visibleListings: Listing[];
    listingGroups: ListingGroup[];
    isActive?: boolean;
};

const NavMessaging: React.FC<Props> = ({visibleListings, listingGroups, isActive}) => {
    const {isOpen, onOpen, onClose} = useDisclose();

    if (visibleListings.length > 1 || listingGroups.length) {
        return (
            <Popover
                hasArrow
                isOpen={isOpen}
                trigger={
                    <TopNavMenuItem icon="chevron-down" isActive={isActive} to={onOpen}>
                        Messaging
                    </TopNavMenuItem>
                }
                onClose={onClose}
            >
                <MessagingMenu listingGroups={listingGroups} onClick={onClose} />
            </Popover>
        );
    }
    if (visibleListings.length === 1) {
        return (
            <TopNavMenuItem to={`/messaging/${visibleListings[0]._id}`}>Messaging</TopNavMenuItem>
        );
    }
    return (
        <Popover
            isOpen={isOpen}
            trigger={
                <TopNavMenuItem icon="chevron-down" isActive={isActive} to={onOpen}>
                    Messaging
                </TopNavMenuItem>
            }
            onClose={onClose}
        >
            <Center>
                <Text variant="sm">Nothing Found</Text>
            </Center>
        </Popover>
    );
};

export default memo(NavMessaging);
